import {Component, output, Input, OnInit, ViewChild, ElementRef, OnDestroy} from '@angular/core';
import { FormsModule} from '@angular/forms';
import { DatePickerModule, DatePickerMonthChangeEvent, DatePicker } from 'primeng/datepicker';
import { getMaxDepartureDate, IAvailabiltyDatesResponseItem, INotification, IPrimeDatepickerDate, NotificationService, PimNotificationComponent, SettingsService } from 'core-lib';
import { BreakpointObserverService } from 'core-lib';
import { TranslateModule } from '@ngx-translate/core';
import { AvailabilityService } from 'core-lib';
import { MessageModule } from 'primeng/message';
import dayjs, { Dayjs } from 'dayjs';
import unionBy from 'lodash/unionBy';
import { Subscription } from 'rxjs';
import isBetween from 'dayjs/plugin/isBetween' // ES 2015
dayjs.extend(isBetween);



@Component({
    selector: 'app-datepicker',
    imports: [FormsModule, DatePickerModule, TranslateModule, MessageModule, PimNotificationComponent],
    templateUrl: './datepicker.component.html',
    styleUrl: './datepicker.component.scss'
})
export class DatepickerComponent implements OnInit, OnDestroy {
  @Input() rangeDates: Date[] = [];
  @Input() showAvailability:boolean = true;
  @Input() showPrices:boolean = false;
  @Input() hotelCode:string;
  @Input() category:string;
  @ViewChild('dp') dp:DatePicker;
  onValueChange = output<Date[]>();

  minDate:Date =  new Date();
  maxDate:Date|null = null;
  hoverDate:number|null = null;
  isMobile:boolean =  false;
  availabilityDates:IAvailabiltyDatesResponseItem[]|null = null;
  notifications:INotification[];
  notificationsForMonth:INotification[];
  private subs: Subscription[] = []

  constructor(
    public settings: SettingsService, 
    private breakpoints: BreakpointObserverService,
    private avService: AvailabilityService,
    private notificationService: NotificationService
  ) {

  }

  ngOnInit(): void {
    // set the initial dates. today and today +1 if not already selected before
    
    this.minDate.setHours(0);
    this.minDate.setMinutes(0);
    this.minDate.setSeconds(0);
    this.minDate.setMilliseconds(0);

    this.subs.push(
      this.breakpoints.screenSizeObserver.subscribe((val) => {
        if (val < 768) {
          this.isMobile = true
        }
        else {
          this.isMobile = false
        }
      })
    );

    this.notifications = this.notificationService.getfilteredNotificationsForPhase('datepicker');
    
    if (typeof this.rangeDates[0] == 'undefined') {
      this.rangeDates[0] = new Date();
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.rangeDates[1] = tomorrow;

      // tämä kommentoitu pois, jotta occupancy ei olisi heti auki. Jos bugeja esiintyy päivämäärien kanssa, ota takaisin
      //this.onValueChange.emit(this.rangeDates);
    }


    //get "traffic lights for 3 months from today and starting from selected arrival date's first of month."
    let arrival:dayjs.Dayjs|string = dayjs(this.rangeDates[0]).subtract(1,'month').startOf('month')
    if (arrival.isBefore(dayjs())) {
      arrival = dayjs();
    }
    let departure = arrival.add(3, 'months').format('YYYY-MM-DD');
    arrival = arrival.format('YYYY-MM-DD');
   
    if (this.hotelCode && this.hotelCode.length > 0 && this.hotelCode != 'ALL') {
      this.subs.push(
        this.avService.getDatePickerAvailability(this.hotelCode, arrival, departure).subscribe((res) => {
          this.availabilityDates = res;
        })
      );
    }

    if (this.rangeDates[0]) {
      this.getFooterAvertisementText(this.rangeDates[0].getMonth(), this.rangeDates[0].getFullYear());
    }    
  }

  handleOnShow() {
    if (this.rangeDates[0]) {
      this.getFooterAvertisementText(this.rangeDates[0].getMonth()+1, this.rangeDates[0].getFullYear());
    }   
  }

  handleMonthChange(event:DatePickerMonthChangeEvent) {

    if (event.month && event.year) {
      let month:number = event.month;
      let year:number = event.year;
    
    
      if (month <= dayjs().get('month') && year <= dayjs().get('year')) {
        // prevent going back months before today.
        this.dp.navForward(event)
        return;
      }
  
      // get availability for 1 month in advance and 1 before.
  
  
      let arrival:dayjs.Dayjs|string = dayjs(`${event.year}-${event.month}-01`).subtract(1,'month')
      if (arrival.isBefore(dayjs())) {
        arrival = dayjs();
      }
      arrival = arrival.format('YYYY-MM-DD');
      let departure = dayjs(arrival).add(3,'month').format('YYYY-MM-DD');
  
      if (this.hotelCode && this.hotelCode.length > 0 && this.hotelCode != 'ALL') {
        this.subs.push(
          this.avService.getDatePickerAvailability(this.hotelCode, arrival, departure).subscribe((res) => {
            // combine availability and remove duplicate dates.
            this.availabilityDates = unionBy(this.availabilityDates, res, 'date');
          })
        );
      }
      
      this.getFooterAvertisementText(month, year);
    }
    
  }

  getFooterAvertisementText(month:number, year:number) {   
    this.notificationsForMonth = [];

    this.notifications.forEach((notification:INotification) => {
      let notificationArrival = notification.arrival ? dayjs(notification.arrival?.value) : null;
      let notificationDeparture = notification.departure ? dayjs(notification.departure?.value) : null;

      // set always to start and end of month, because we need to show for whole month in calendar
      if (notificationArrival) {
        notificationArrival = notificationArrival.date(1)
      }
      if (notificationDeparture) {
        notificationDeparture = notificationDeparture.date(1).add(1, 'month').subtract(1, 'day'); // set to last day of month by setting to first day of month, adding 1 month and subtracting 1 day
      }

      let dpDate = dayjs(`${year}-${month}-1`);

      if (notificationArrival == null || dpDate.isBetween(notificationArrival, notificationDeparture, 'day', '[]')) {
        this.notificationsForMonth.push(notification);
      }
    });
    
    
    
    
  }

  handleDatepickerSelect(event:Date) {
    
    if (this.rangeDates[1] == null) {
      let nextDay = new Date(this.rangeDates[0]);
      nextDay.setDate(nextDay.getDate() + 1);

      this.minDate = nextDay;
      // the availability API accepts at most MAX_STAY_NIGHTS nights
      this.maxDate = getMaxDepartureDate(this.rangeDates[0]);
    }
    else {
      this.resetSelectionLimits();
    }
    // ensure that dates have zero hours etc. Fixes today date not showing on init.
    this.rangeDates.forEach((d:Date|null) => {
      if (d) {
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);
      }
    });
    this.onValueChange.emit(this.rangeDates);
  }

  handleClickOutside() {
    if (this.rangeDates.length == 1 ||this.rangeDates[1] == null || typeof this.rangeDates[1] == 'undefined') {
      const nextDay = new Date(this.rangeDates[0]);
      nextDay.setDate(nextDay.getDate() + 1);
      this.rangeDates[1] = nextDay;
      this.resetSelectionLimits();
    }
  }

  /** Opens the calendar, e.g. when the stay from a deeplink was invalid and the user has to pick new dates. */
  open() {
    this.dp?.showOverlay();
  }

  // after a complete range any date from today on can start a new selection
  private resetSelectionLimits() {
    let today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    this.minDate = today;
    this.maxDate = null;
  }


  isInFuture(date: IPrimeDatepickerDate) {
    if (this.rangeDates && this.rangeDates[1] == null) {
      //let hoverDate = Date.parse(`${date.year}-${date.month+1}-${date.day}`);
      let selectedDate = this.rangeDates[0].getTime();
      let dateToCheck = Date.parse(`${date.year}-${date.month+1}-${date.day}`);
      if (this.hoverDate) {
        const isSelectable = !this.maxDate || dateToCheck <= this.maxDate.getTime();
        if (selectedDate < dateToCheck && dateToCheck <= this.hoverDate && isSelectable) {
          return true;
        }
      }     
    }
    return false;
  }

  isSelectedArrival(date: IPrimeDatepickerDate) {
    if (this.rangeDates && this.rangeDates[1] == null) {
      let selectedDate:any = dayjs(this.rangeDates[0]);
      let dateToCheck = dayjs(`${date.year}-${date.month+1}-${date.day}`);

      if (selectedDate.isSame(dateToCheck, 'day')) {
        return true;
      }
    }
    return false;
  }

  setHoveredDate(date: IPrimeDatepickerDate)  {
    this.hoverDate = Date.parse(`${date.year}-${date.month+1}-${date.day}`);
  }

  getDatepickerAvailabilityBall(date:IPrimeDatepickerDate) {
    let dateToCheck = dayjs(`${date.year}-${date.month+1}-${date.day}`).format('YYYY-MM-DD');
    let dateAv = this.availabilityDates?.find((d:IAvailabiltyDatesResponseItem) => {
      return d.date == dateToCheck;
    });

    if (dateAv) {
      
      let dateAvailability = dateAv.totalAvailability;
      if (this.category && this.category != 'ALL' && dateAv.perCategory) {
        dateAvailability = dateAv.perCategory[this.category];
      }

      if (dateAvailability < 1) {
        return 'soldout';
      }
      else if (dateAvailability < 10) {
        return 'fewleft';
      }
      return 'available';
    }
    
    return 'nodata';    
  }
  getMinPrice(date:IPrimeDatepickerDate) {
    // not implemented yet
    return '';
  }

  mapNotificationColor(color:string):"error" | "success" | "info" | "warn" | "secondary" | "contrast" | null | undefined {
    return this.notificationService.mapNotificationColor(color);
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe())
  }
}
